module.exports = __webpack_public_path__ + "static/media/stars-less-750.c5547f7d.webp";